import axiosClient from './axiosClient'
const configNotificationResourceApi = {
  checkCompanyExpiration: () => {
    const url = '/config-notification-resource/checkPackageExpiration'
    return axiosClient.post(url)
  },
}
export default configNotificationResourceApi
